import { AnyFieldApi } from '@tanstack/react-form-nextjs'

import { cn } from '@/utils'

export const FieldInfo = ({
  className,
  errorMessage,
  field
}: {
  className?: string
  errorMessage?: string
  field: AnyFieldApi
}) => {
  const error =
    errorMessage ||
    (field.state.meta.errors || Object.values(field.state.meta.errorMap))
      .map((err) => (typeof err === 'string' ? err : err.message))
      .join(', ')

  return (
    <>
      {field.state.meta.isTouched && error ? (
        <em className={cn('text-destructive text-xs', className)}>{error}</em>
      ) : null}
      {field.state.meta.isValidating ? (
        <em className={cn('text-destructive text-xs', className)}>
          Validating...
        </em>
      ) : null}
    </>
  )
}
